import { useSnapshot } from "valtio"
import { AgmodalStore, aguserStore, configStore, loginStore, routerStore, } from "../state/CommonState"
import { $c, $cg, $cr, AgInput, AgPhone, AgSelect } from '../components/AgComponents'
import AguserApi from "../state/AguserApi"
import { useEffect, useRef, useState } from "react"
import on from "../components/on2.png"
import off from "../components/off.png"
import Api from "../state/Api"
import { Roles, ServerLists } from "../StaticData"
import UserEntity from "./user-entity"
import {
  VERTICALS,
  ROLES,
  DIVISION,
  CUSTOMERROLES,
  PERMISSIONS,
  ENTITYCATEGORY,
  CARGOHANDLINGTYPE,
  SALESVERTICAL
} from "../util/constants"
import { Agyesno } from "../components/Agyesno"
import RoleUtils from "../util/RoleUtils"
import { useNavigate } from 'react-router-dom'
import DropdownIcon from "../assets/images/dropdownIcon1.svg"
import TenantUtils from "../util/tenant.utils"
import { Col1, Col2, Col5, Col8, Col9, Columns } from "../Controls"
import { MultiSelectField } from "../port-to-port-schedules/multi-select"
import { useForm } from "react-hook-form"
import EntityApi from "../state/entity-api"
import { loadCSC } from "../util/country-service"

export default function EditAguser(props) {
    let navigate = useNavigate()
    const aguser = aguserStore.aguserRec
    const [checked1, setChecked] = useState(
      aguser.isAgragaUser ? aguser.isAgragaUser : "Yes"
    )

  let usertypes = ["Entity", "Branch"]
  let productTypes = ["FCL", "LCL", "AIR"]
  let tradeTypes = ["Export", "Import", "Cross Trade"]
  let subroletypes = ["Docs", "Visibility", "Co-Ordination", "Execution"]
  let nominationtypes = ["Yes", "No"]

    const [roleChecked, setRoleChecked] = useState({}); 
    const [salesChecked, setSalesChecked] = useState({}); 
    const [showInvite, setShowInvite] = useState(false)
    const [firstNameError, setFirstNameError] = useState("")
    const [emailError, setEmailError] = useState("")
    const [phoneError, setPhoneError] = useState("")
    const [roleError, setRoleError] = useState("")
    const [CountryList, setCountryList] = useState([])
    const [userdata , setUserdata] = useState(JSON.parse(JSON.stringify(aguserStore.aguserRec)))

    let title = 'Create New User'
    if (props.mode !== 'new') {
        title = 'Modify User Details'
        if (!showInvite && aguser.status === 'ACTIVE' && aguser.password !== '') setShowInvite(true)
    }
    
    useSnapshot(aguserStore)
    const [roles, setRoles] = useState([])
    const [password, setPassword] = useState(aguserStore.aguserRec.password)
    const [country, setCountry] = useState(aguserStore)
    const [department, setDepartment] = useState('')
    const [cursor, setCursor] = useState(0)
    const [salesVertical, setSalesVertical] = useState([])
    const [childError, setChildError] = useState(false)
    const [loading , setLoading] = useState(false)
    const ref = useRef(null)
    const [rolesList, setRolesList] = useState([])
    const [cuslist, setCusList] = useState([])
    const [Countries, setCountries] = useState([]);

  const aguserrec = useForm({
    defaultValues: aguserStore.aguserRec,
  });
  const {
    control,
    watch,
    register,
    setValue,
    // handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    trigger,
    getFieldState,
    getValues,
    setError
  } = aguserrec;
    useEffect(() => {
        const input = ref.current
        if (input) {
            input.setSelectionRange(cursor, cursor)
        }
    }, [ref, cursor])
    useEffect(() => {
        console.log('Useeffect alled inside edit aguser')
        console.log('>>>>>>>>>>', JSON.stringify(loginStore))
        const newval = "Yes" 
        setChecked(newval)
        aguser.isAgragaUser = newval
        if (loginStore.userRec.aguserRec.role.includes( `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()} ADMIN`))
            AguserApi.getRoles(setRoles)
        else 
            setRoles(['','CLIENT USER', 'CLIENT ADMIN'])

        if (
          props.mode !== "new" &&
          aguser.isAgragaUser === "Yes" &&
          aguser.vertical
        ) {
          AguserApi.getManagersForAgusers(aguser.vertical, setManagersForAgusers)
          if(aguser.vertical !== VERTICALS.CENTRAL){
          AguserApi.getbranchesForTypes(aguser, setbranchesForTypes) 
          }else if (aguser.vertical === VERTICALS.CENTRAL && (aguser.department === 'Finance'  || aguser.department === 'Central Operations')){
          AguserApi.getbranchesForTypes(aguser, setbranchesForTypes) 
          }
        }

        if(editMode()){
            let initialSalesCheckedState={}
          cbAdminSalesVertical.forEach((data, index) => {
               if(aguser.AdminSalesVertical.includes(data)){
                initialSalesCheckedState[index] = 'Yes';
              }else{
                initialSalesCheckedState[index] = 'No';
              }
          });
          setSalesChecked(initialSalesCheckedState);
        }
      
        const init = async () => {
        let currentRoleOptionsNew = await AguserApi.getAllRolesList()
        setRolesList(currentRoleOptionsNew)
        console.log(currentRoleOptionsNew, "currentRoleOptionsNew")
        }

        init()
    }, [])


    const [branchesForTypes, setbranchesForTypes] = useState([])
    const [managersForAgusers, setManagersForAgusers] = useState([])


    const isBranchHeadRole = aguser.role.includes(ROLES.DT.BRANCH_HEAD)
    const isAdminRole = aguser.role.includes(ROLES.DT.ADMIN)
    const rmOnChnage = async (role) => {
      
      const isBranchHead = aguser.role.includes(ROLES.DT.BRANCH_HEAD) || aguser.role.includes(ROLES.DT.RMSUPPLY_OPERATIONSANDINVOICING)
      const isCentralManager = aguser.vertical === VERTICALS.CENTRAL
      const isDTAdmin = aguser.vertical === VERTICALS.DOMESTIC_TRANSPORT &&aguser.role.includes(ROLES.DT.ADMIN)
      const isCBAdmin = aguser.vertical === VERTICALS.CROSS_BORDER && aguser.role.includes(ROLES.CB.ADMIN);

      if (isBranchHead) {
        aguser.division = DIVISION.BRANCH
        await AguserApi.getbranchesForTypes(aguser, setbranchesForTypes)
      }
      else if (isCentralManager && (aguser.department === 'Finance' ||  aguser.department === 'Central Operations')){
           aguser.division = DIVISION.NATIONAL
         await AguserApi.getbranchesForTypes(aguser, setbranchesForTypes)
      }
    }

    const targetCountries = ["India", "China", "Hong Kong", "United States"];

    useEffect(() => {
      if (editMode) {
        const contryList =  ServerLists.countryNameList.filter(d => targetCountries.includes(d))
        setCountryList(contryList) 
      }
    }, [])


    useEffect(() => {
      cbAdminSalesVertical.forEach((data, index) => {
        if(props.mode === 'new'){
        if (salesChecked[index] === 'Yes') {
          if (!aguser.AdminSalesVertical.includes(data)) {
            aguser.AdminSalesVertical.push(data);
          }  
        }else if(salesChecked[index] === 'No'){
          aguser.AdminSalesVertical = aguser.AdminSalesVertical.filter(salesVer => salesVer !== data);
        }
      } else if(props.mode === 'edit'){
          if(salesChecked[index] === 'Yes'){
            if (!aguser.AdminSalesVertical.includes(data)) {
              aguser.AdminSalesVertical.push(data);
          }           
          }else if(salesChecked[index] === 'No') {
          aguser.AdminSalesVertical = aguser.AdminSalesVertical.filter(salesVer => salesVer !== data);
          }
        }
      });
    }, [salesChecked]);

  useEffect(() => {
    EntityApi.getcustomerList((data) => {
      setCusList(data?.results)
    })
    filterCountries()
  }, [])

    const editMode = ()=>{
      return props.mode === "edit"
    }
   
    function isEmailValid(email) {
      const domain = process.env.REACT_APP_ENTERPRISE_DOMAIN; 
    const escapedDomain = domain.replace('.', '\\.'); 
    const pattern = new RegExp(`^[\\w.\\-+]+@${escapedDomain}$`, 'i');
      return pattern.test(email)
    }

    const divisonOnChnage = () => {
      AguserApi.getbranchesForTypes(aguser, setbranchesForTypes)
    }

    function trimStr(str) {
        if(!str) return str;
  return str.replace(/^\s+/g, '');
    }

    const handleChange = (e, r) => {
        setCursor(e.target.selectionStart)
        const { value } = e.target
        if (r == 'email') {
          aguser.vertical = ""
          aguser.role = []
          aguser.division = ""
          aguser.branch = ""
          aguser.regional = ""
          aguser.zonal = ""
          aguser.national = ""
          aguser.reportingManager = ""
          aguser.country = "India"
          aguser.phonePrefix = "+91"
          aguser.phone=""
          // const newval = "No";
          // setChecked(newval);
          // aguser.isAgragaUser = newval;
        }
        if (r == 'firstName' || r == 'lastName' || r == 'companyName' || r == 'erpEmployeeCode') {
            aguser[r] = trimStr(e.target.value)
        } else {
            aguser[r] = e.target.value.trim()
        }

    // Validate the first name
    if ("firstName" === r) {
      if (
        /^[A-Z0-9a-z\s]+$/.test(value) &&
        value.length >= 1 &&
        value.length <= 25
      ) {
        setFirstNameError("")
      } else {
        setFirstNameError(
          "Please enter a valid first name with 1 to 25 characters (letters and spaces allowed)."
        )
      }
    }
    if ("role" === r) {
      if (value.length <= 0) {
        setRoleError("Please select a role")
      } else {
        setRoleError("")
      }
    }
  }

  const handleValidationComplete = (data) => {
    return data !== null ? setChildError(true) : setChildError(false)
  }

  const handleBlur = (e, r) => {
    const { value } = e.target
    if ("email" === r) {
      aguser.email = e.target.value.replace(/ /g, "").toLowerCase()

      if (/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)) {
        setEmailError("")
      } else {
        setEmailError("Please enter a valid email ID")
      }
    } else if ("phone" === r) {
      aguser.phone = e.target.value.replace(/ /g, "")

      if (aguser.country === "India") {
        if (/^\d{10}$/.test(aguser.phone)) {
       //  if(aguser.country != "China"){
          setPhoneError("")  
        // }
          
        } else {
          // configStore.setModalMessage(`Please enter the valid mobile number`)
          setPhoneError(
            "Please enter a valid 10-digit phone number for India."
          )
        }

        // Validate the first name
        if ('firstName' === r) {
          if (/^[A-Z0-9a-z\s]+$/.test(value) && value.length >= 1 && value.length <= 25) {
            setFirstNameError('')
          } else {
            setFirstNameError('Please enter a valid first name with 1 to 25 characters (letters and spaces allowed).')
          }

        }
        if ('role' === r) {
          if (value.length <= 0) {
            setRoleError('Please select a role')
          } else {
            setRoleError('')
          }
        }

      } else if(aguser.country !== "India" && aguser.isAgragaUser === "Yes") {
        setPhoneError("")
      } else {
        if(aguser.phone === "")
        setPhoneError("Field is mandatory")
      }

    } else {
      if (/^\d{7,15}$/.test(aguser.phone)) {
        // Change '7-15' to '7,15'
        setPhoneError("")
      } else {
        setPhoneError(
          "Please enter a valid phone number between 7 and 15 digits for other countries."
        )
      }
    }
  }

 const filterCountries = () => {
      loadCSC().then(csc => {
        const array = csc.Country.getAllCountries().filter(
          (x, i) => csc.State.getStatesOfCountry(x.isoCode).length !== 0
        );
        setCountries(array);
      }).catch(console.error);
    };

  const handleSubmit1 = (e) => {
    e.preventDefault()

    // If all validations pass, submit the form
    console.log(aguser, "submitting")
    if (aguser.firstName === '' || aguser.email === '' || (aguser.phone === '' && aguser.isAgragaUser === "Yes" && aguser.country === 'India') ||
    (aguser.phone === '' && aguser.isAgragaUser === "No") ) {
      const mandate = 'Field is mandatory'
      if (aguser.firstName === '') {
        setFirstNameError(mandate)
      }
      if (aguser.email === '') {
        setEmailError(mandate)
      }
      if (aguser.phone === '') {
        //
        if(( aguser.country !== 'India') && aguser.isAgragaUser === "Yes"){
          setPhoneError("")
        } 
        if(aguser.country == "India") {
          configStore.setModalMessage(`Please enter the valid mobile number`)
          setPhoneError(mandate)
        }
        //  if (aguser.country == "Hong Kong"){
        //    setPhoneError("")
        //  }
        //  setPhoneError(mandate)
      } else {
        setPhoneError("")
      }
      if (aguser.role === '') {
        setRoleError(mandate)
      }
    } else if ((!aguser.email.includes(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) && RoleUtils.isUserAuthorized(PERMISSIONS.CREATE.NEW_CUSTOMER_USER))) {
      if (aguser.email.indexOf('@') < 0) {
        configStore.setModalMessage(`Invalid email ${aguser.email}`)
        return
      }

      if (!aguser.role) {
        configStore.setModalMessage(`Role need to be selected || Check the email address`)
        return
      }
       

      if (aguser.status === 'ACTIVE' && aguser.password === '') {
        const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
        const passwordLength = 12
        let password = ""
        for (var i = 0;i <= passwordLength;i++) {
          var randomNumber = Math.floor(Math.random() * chars.length)
          password += chars.substring(randomNumber, randomNumber + 1)
        }
        aguser.password = password
        aguser.status = 'ACTIVE'
      }
      /*if (aguser.password === password) {*/
      if (props.mode === 'new') AguserApi.createUser((saved) => {
        if (saved) setShowInvite(true)
      })
      else AguserApi.saveUser()
      AgmodalStore.apiCall = true
      routerStore.agusersCurrentView = "list"
    } else if ((aguser.email.includes(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) && RoleUtils.isUserAuthorized(PERMISSIONS.CREATE.NEW_AGRAGAUSER))) {
      if (aguser.email.indexOf('@') < 0) {
        configStore.setModalMessage(`Invalid email ${aguser.email}`)
        return
      }
      if (aguser.isAgragaUser === 'Yes' && !aguser.vertical) {
        configStore.setModalMessage(`Vertical need to be selected`)
        return
      }
      if (!aguser.role) {
        configStore.setModalMessage(`Role need to be selected || Check the email address`)
        return
      }
      if (aguser.vertical != 'Central') {
        if (aguser.isAgragaUser === 'Yes' && !aguser.division) {
          configStore.setModalMessage(`Division need to be selected`)
          return
        }
        if (aguser.isAgragaUser === 'Yes' && (!aguser.zonal && !aguser.regional && !aguser.branch && !aguser.national) && aguser.division != 'National') {
          configStore.setModalMessage(`Branch/Zone/Region need to be selected`)
          return
        }
        // if (aguser.isAgragaUser && !aguser.reportingManager) {
        //     configStore.setModalMessage(`Please select the Reporting Manager`)
        //     return
        // }

      }

      if (aguser.status === 'ACTIVE' && aguser.password === '') {
        const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
        const passwordLength = 12
        let password = ""
        for (var i = 0;i <= passwordLength;i++) {
          var randomNumber = Math.floor(Math.random() * chars.length)
          password += chars.substring(randomNumber, randomNumber + 1)
        }
        aguser.password = password
        aguser.status = 'ACTIVE'
      }
      /*if (aguser.password === password) {*/
      if (props.mode === 'new') AguserApi.createUser((saved) => {
        if (saved) setShowInvite(true)
      })
      else AguserApi.saveUser()


    }
    else {
      configStore.setModalMessage(`Create user permission needed`)
      return
    }
    /* } else configStore.setModalMessage('Passwords do not match')*/


  }
  
  const handleSubmit = (e)=>{
    e.preventDefault()
    if(aguser.vertical === 'Cross-Border' && aguser.department !== 'Admin'){
      aguser.AdminSalesVertical = []
     }

     if(aguser.vertical === 'Cross-Border' && aguser.department !== 'Relationship Manager'){
      aguser.RMSalesVertical = []
     }
      // If all validations pass, submit the form
      console.log(aguser, "submitting")
      const mandate = 'Field is mandatory'
      if (aguser.isAgragaUser==="Yes") {
        if (aguser.firstName === '') {
          setFirstNameError(mandate)
         return configStore.setModalMessage(`Please enter a valid First Name`)
        }
         if(aguser.firstName.length > 1){
          if (/^[A-Z0-9a-z\s]+$/.test(aguser.firstName) && aguser.firstName.length >= 1 && aguser.firstName.length <= 25) {
            setFirstNameError('')
          } else {
            setFirstNameError('Please enter a valid first name with 1 to 25 characters (letters and spaces allowed).')
          return  configStore.setModalMessage(`Please enter a valid first name with 1 to 25 characters (letters and spaces allowed).`)
          }
        }
        if (aguser.email === '') {
          setEmailError(mandate)
          return configStore.setModalMessage(`Please enter a valid email ID`)
         
        }
        if (aguser.email.length > 1) {
          aguser.email = aguser.email.trim().replace(/ /g, "").toLowerCase()
    
          if (/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(aguser.email)) {
            setEmailError("")
          } else {
            setEmailError("Please enter a valid email ID")
            return configStore.setModalMessage(`Please enter a valid email ID`)
          }
          console.log(aguser.email.includes(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`),RoleUtils.isUserAuthorized(PERMISSIONS.CREATE.NEW_AGRAGAUSER));
          if ((!aguser.email.includes(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) && RoleUtils.isUserAuthorized(PERMISSIONS.CREATE.NEW_AGRAGAUSER))) {
           return configStore.setModalMessage(`Please enter a valid ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} email ID`)
          }
          if (aguser.email.indexOf('@') < 0) {
            configStore.setModalMessage(`Invalid email ${aguser.email}`)
            return
          }
        }
        if (aguser.phone === '' && aguser.country == "India") {
          setPhoneError(mandate)
          return configStore.setModalMessage(`Please enter the valid mobile number`)
        }
        else {
          if (/^\d{10}$/.test(aguser.phone) && aguser.country == "India") {
            setPhoneError("")      
          }
          else {
            if(( aguser.country !== 'India')){
              setPhoneError("")
            } 
            if(aguser.country == "India") {
              setPhoneError(mandate)
              return configStore.setModalMessage(`Please enter the valid mobile number`)
            }
          }

        }           
           if (!aguser.vertical) {
            configStore.setModalMessage(`Vertical need to be selected`)
            return
          }
        if (aguser?.role?.length === 0) {
          return configStore.setModalMessage(`Please select atleast one role`)
        }
        if (aguser?.rolePerm?.length === 0) {
          return configStore.setModalMessage(`Please select atleast one role permission`)
        }
        if ((aguser?.department == ROLES.CENTRAL.CENTRAL_OPERATIONS || aguser?.department == ROLES.CB.PROCUREMENT) && aguser?.entityCategory?.length === 0) {
          return configStore.setModalMessage(`Entity Category needs to be selected`)
        }
        if ((aguser?.department == ROLES.CENTRAL.CENTRAL_OPERATIONS || aguser?.department == ROLES.CB.PROCUREMENT) && aguser?.cargoHandlingType?.length === 0) {
          return configStore.setModalMessage(`Cargo Handling Type needs to be selected`)
        }
        if (aguser?.department == ROLES.CB.PROCUREMENT && (!aguser?.nomination)) {
          return configStore.setModalMessage(`Nomination needs to be selected`)
        }
        if (aguser?.department == ROLES.CB.PROCUREMENT && (!Array.isArray(aguser?.tradeType) || aguser.tradeType.length === 0)) {
          return configStore.setModalMessage(`Trade Type needs to be selected`)
        }
        if(aguser.vertical===VERTICALS.CROSS_BORDER && aguser.department === 'Relationship Manager' &&aguser.RMSalesVertical?.length===0){
          return configStore.setModalMessage(`Please select atleast one RM Sales Vertical`)
        }

        if(aguser.vertical===VERTICALS.CROSS_BORDER && aguser.department === 'Admin' && aguser.AdminSalesVertical?.length===0 && aguser.status !== 'INACTIVE'){
          return configStore.setModalMessage(`Please select atleast one Admin Sales Vertical`)
        }
      if (aguser.vertical != VERTICALS.CENTRAL) {
          if (aguser.isAgragaUser === 'Yes' && !aguser.division) {
            configStore.setModalMessage(`Division need to be selected`)
            return
          }
          if (aguser.isAgragaUser === 'Yes' && (!aguser.zonal && !aguser.regional && !aguser.branch && !aguser.national) && aguser.division != 'National') {
            configStore.setModalMessage(`Branch/Zone/Region need to be selected`)
            return
          }
          // if (aguser.isAgragaUser && !aguser.reportingManager) {
          //     configStore.setModalMessage(`Please select the Reporting Manager`)
          //     return
          // }
  
        }

        if ((aguser.vertical === VERTICALS.CENTRAL || aguser.vertical === VERTICALS.CROSS_BORDER) && aguser.department !== `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Admin` && aguser.reportingManager === "") {
          return configStore.setModalMessage(`Reporting Manager needs to be selected`)
         }

        if (aguser.department === 'Central Operations') {
          if (aguser?.branches?.length === 0) {
            return configStore.setModalMessage(`Please select atleast one branch`)
          }
          if (aguser?.products?.length === 0) {
            return configStore.setModalMessage(`Please enter atleast one products`)
          }
          if (aguser?.nominations?.length === 0) {
            return configStore.setModalMessage(`Please enter atleast one nomination`)
          }
          if (aguser?.tradeTypes?.length === 0) {
            return configStore.setModalMessage(`Please enter atleast one Trade Type`)
          }
          // if (aguser?.customers?.length === 0) {
          //   return configStore.setModalMessage(`Please enter atleast any one customer`)
          // }
          if (aguser?.subRoles?.length === 0) {
            return configStore.setModalMessage(`Please enter atleast one Sub Role`)
          }
        }

         if (aguser.department === 'Finance') {
          if (aguser?.branches?.length === 0) {
            return configStore.setModalMessage(`Please select atleast one branch`)
          }
          if(aguser.entityCategory === '' || !aguser.entityCategory){
           return configStore.setModalMessage(`Entity category needs to be selected.`)
          }
      
          // if (aguser?.customers?.length === 0) {
          //   return configStore.setModalMessage(`Please enter atleast any one customer`)
          // }
         
        }
        if(aguser?.isSales == true && (!aguser?.salesUserType || aguser?.salesUserType == "")){
         return configStore.setModalMessage(`Sales user type needs to be selected.`)
        }

        if (aguser.status === 'ACTIVE' && aguser.password === '') {
          const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
          const passwordLength = 12
          let password = ""
          for (var i = 0;i <= passwordLength;i++) {
            var randomNumber = Math.floor(Math.random() * chars.length)
            password += chars.substring(randomNumber, randomNumber + 1)
          }
          aguser.password = password
          aguser.status = 'ACTIVE'
        }
        if (props.mode === 'new') AguserApi.createUser((saved) => {
          if (saved) {
            setShowInvite(true)
            inviteMailFn()
          }
        })
        else AguserApi.saveUser()
      }
      else if(aguser.isAgragaUser==="No"){
        // 
        if (aguser.firstName === '') {
          setFirstNameError(mandate)
         return configStore.setModalMessage(`Please enter a valid First Name`)
        }
         if(aguser.firstName.length > 1){
          if (/^[A-Z0-9a-z\s]+$/.test(aguser.firstName) && aguser.firstName.length >= 1 && aguser.firstName.length <= 25) {
            setFirstNameError('')
          } else {
            setFirstNameError('Please enter a valid first name with 1 to 25 characters (letters and spaces allowed).')
          return  configStore.setModalMessage(`Please enter a valid first name with 1 to 25 characters (letters and spaces allowed).`)
          }
        }
        if (aguser.email === '') {
          setEmailError(mandate)
          return configStore.setModalMessage(`Please enter a valid email ID`)
         
        }
        if (aguser.email.length > 1) {
          aguser.email = aguser.email.replace(/ /g, "").toLowerCase()
    
          if (/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(aguser.email)) {
            setEmailError("")
          } else {
            setEmailError("Please enter a valid email ID")
            return configStore.setModalMessage(`Please enter a valid email ID`)
          }
          console.log(aguser.email.includes(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`),RoleUtils.isUserAuthorized(PERMISSIONS.CREATE.NEW_CUSTOMER_USER));
          if ((aguser.email.includes(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) && RoleUtils.isUserAuthorized(PERMISSIONS.CREATE.NEW_CUSTOMER_USER))) {
           return configStore.setModalMessage(`Please enter a valid email ID`)
          }
          if (aguser.email.indexOf('@') < 0) {
            configStore.setModalMessage(`Invalid email ${aguser.email}`)
            return
          }
        }
        if (aguser.phone === '') {
          setPhoneError(mandate)
          return configStore.setModalMessage(`Please enter the valid mobile number`)
        }

      
        if (aguser.status === 'ACTIVE' && aguser.password === '') {
          const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
          const passwordLength = 12
          let password = ""
          for (var i = 0;i <= passwordLength;i++) {
            let randomNumber = Math.floor(Math.random() * chars.length)
            password += chars.substring(randomNumber, randomNumber + 1)
          }
          aguser.password = password
          aguser.status = 'ACTIVE'
        }
        /*if (aguser.password === password) {*/
        if (props.mode === 'new') AguserApi.createUser((saved) => {
          if (saved){ 
            setShowInvite(true)
            inviteMailFn()
          }
        })
        else AguserApi.saveUser()
      }
  }

  const randomBytes = (count) => {
    const result = Array(count)
    for (let i = 0;i < count;++i) {
      result[i] = Math.floor(256 * Math.random())
    }
    return result
  }

    const bin2hex = () =>
    {
    let bin = randomBytes(32)
      var i = 0, l = bin.length, chr, hex = ''
    
      for (i; i < l; ++i)
      {
    
        chr = bin[i].toString(16)
    
        hex += chr.length < 2 ? '0' + chr : chr
    
      }
    
      return hex
    
    }
  const getType = () => {
    if (aguser.branch) return aguser.branch
    if (aguser.zonal) return aguser.zonal
    if (aguser.regional) return aguser.regional
  }

  const salesVerticalOptions = [
    'Automotive',
    'Pharma',
    'Renewable Energy',
    'New Age Enterprise',
    'Market Place',
    'MSME',
    'Enterprise',
    'Contract Manufacturer'
  ];

  const cbAdminSalesVertical = ['Automotive', 'Pharma', 'Renewable Energy', 'New Age Enterprise', 'Market Place', 'MSME', 'Enterprise','Contract Manufacturer'];

  const handleClick = () => {
    aguser.vertical = ""
    aguser.role = []
    aguser.division = ""
    aguser.branch = ""
    aguser.regional = ""
    aguser.zonal = ""
    aguser.national = ""
    aguser.reportingManager = ""
    aguser.companyName = ''
    // const newval = checked1 === "Yes" ? "No" : "Yes"
    const newval = checked1 === "Yes"
    setChecked(newval)
    aguser.isAgragaUser = newval
    aguser.email = ""
    aguser.country = "India"
    aguser.phonePrefix = "+91"
    aguser.phone = ""
    const contryList = ServerLists.countryNameList.filter(d => targetCountries.includes(d))
    if (checked1 === "No") {
      setCountryList(contryList)
    }
  }
    var newcountryarr = []

    const [selectedRole, setSelectedRole] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);

    const rolesData = [
      { label: 'Admin', role: 'Admin', selection: 'single', options: [] },
      { label: 'Branch Head', role: 'Branch Head', selection: 'single', options: [] },
      {
        label: 'Procurement',
        role: 'Procurement',
        selection: 'multiple',
        options: [
          { label: 'Procurement-LCL', role: 'Procurement-LCL' },
          { label: 'Procurement-FCL', role: 'Procurement-FCL' },
          { label: 'Procurement-Air', role: 'Procurement-Air' },
        ],
      },
    ];
  
    const handleRoleChange = (event) => {
      const value = event.target.value;
      setSelectedRole(value);
      const selectedRoleData = rolesData.find((roleData) => roleData.role === value);
      if (selectedRoleData && selectedRoleData.selection === 'multiple') {
        setSelectedOptions([]);
      }
    };

    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef(null)
    useEffect(() => {
      function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false); 
        }
      }
    
      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);
    
    const toggleDropdown = () => setIsOpen(!isOpen)

    const handleCheckboxChange = (dept) => {
      if(aguser?.rolePerm === undefined) aguser.rolePerm = []
      aguser.rolePerm = aguser?.rolePerm?.includes(dept)
      ? aguser?.rolePerm?.filter((item) => item !== dept)
      : [...aguser?.rolePerm, dept];  

        if (!aguser.rolePerm.includes(dept)) {
          const rolesToRemove = roleOptions[dept]?.map((role) => role.value);
          aguser.rolePerm = aguser.rolePerm.filter((role) => !rolesToRemove?.includes(role));
        }
      // }

      const eligibleDepartments = aguser.rolePerm.filter(item => [ROLES.CB.PROCUREMENT, ROLES.CENTRAL.CENTRAL_OPERATIONS].includes(item));
      if (eligibleDepartments.length) {
        console.log(eligibleDepartments, 'eligibleDepartments', dept);
        eligibleDepartments.forEach(dep => {
          const initialCheckedState = {};
          const roleList = [];   
          roleOptions[dep]?.forEach((data, index) => {
            initialCheckedState[index] = 'Yes';
            if (!aguser.rolePerm.includes(data.value)) {
              roleList.push(data.value);
            }
          });
          setRoleChecked(initialCheckedState);
      
          if (roleList.length) {
            aguser.rolePerm.push(...roleList);
          }
        });
      }
      

      // aguser.RMSalesVertical =[]
      if ( aguser.vertical === 'Cross-Border' && dept === ROLES.CB.RELATIONSHIP_MANAGER && salesVerticalOptions.length > 0) {
        aguser.RMSalesVertical.push(salesVerticalOptions[0]);
      }
      

      if (!Array.isArray(aguser.role)) {
      aguser.role = [];
      }
     
      rmOnChnage(aguser.role)


      // aguser.zonal = ""
      // aguser.branch = ""
      // aguser.regional = ""
      // aguser.division = ""
      // aguser.reportingManager = ""
      console.log(roleChecked,'setRoleChecked');
    }
    const handleOptionsChange = (event) => {
      // const options = Array.from(event.target.selectedOptions, (option) => option.value);
      // // setSelectedOptions(options);
      // setSelectedOptions([...selectedOptions, options]);

      const { value } = event.target;
    if (selectedOptions.includes(value)) {
      setSelectedOptions(selectedOptions.filter(option => option !== value));
    } else {
      setSelectedOptions([...selectedOptions, value]);
    }
    };

    
    if (!aguser || !aguser.phonePrefix || aguser.phonePrefix.length <= 0) aguser.phonePrefix = '+91'
    const domain = loginStore.email.split('@')[1]

    const roleOptions = {
      'Procurement':[{ value: ROLES.CB_PROCUREMENT_SUBROLES.LCL_Procurement, label: ROLES.CB_PROCUREMENT_SUBROLES.LCL_Procurement },
                      { value: ROLES.CB_PROCUREMENT_SUBROLES.FCL_Procurement, label: ROLES.CB_PROCUREMENT_SUBROLES.FCL_Procurement},
                      { value: ROLES.CB_PROCUREMENT_SUBROLES.AIR_Procurement, label: ROLES.CB_PROCUREMENT_SUBROLES.AIR_Procurement }],
      'Admin':[{value: ROLES.CB.ADMIN, label: ROLES.CB.ADMIN}],
      'Branch Head':[{value: ROLES.CB.BRANCH_HEAD, label: ROLES.CB.BRANCH_HEAD}],
      'Relationship Manager':[{value: ROLES.CB.RELATIONSHIP_MANAGER, label: ROLES.CB.RELATIONSHIP_MANAGER}],
      'Customer Success':[{value: ROLES.CB.CUSTOMER_SUCCESS, label: ROLES.CB.CUSTOMER_SUCCESS}],
      [`${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Admin`]:[{value: ROLES.CENTRAL.AGRAGA_ADMIN, label: ROLES.CENTRAL.AGRAGA_ADMIN}],
      'Tech & Product':[{value: ROLES.CENTRAL.TECHANDPRODUCT, label: ROLES.CENTRAL.TECHANDPRODUCT}],
      'BPO':[{value: ROLES.CENTRAL.BPO, label: ROLES.CENTRAL.BPO}],
      'Database':[{value: ROLES.CENTRAL.DATABASE, label: ROLES.CENTRAL.DATABASE}],
      'HR':[{value: ROLES.CENTRAL.HR, label: ROLES.CENTRAL.HR}],
      'Finance':[{value: ROLES.CENTRAL.FINANCE, label: ROLES.CENTRAL.FINANCE}],
      'Central Operations':[
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_EXPORT_COORDINATION, label: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_EXPORT_COORDINATION},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_IMPORT_COORDINATION, label: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_IMPORT_COORDINATION},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_EXPORT_COORDINATION, label: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_EXPORT_COORDINATION},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_IMPORT_COORDINTAION, label: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_IMPORT_COORDINTAION},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_EXPORT_DOCUMENTATION, label: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_EXPORT_DOCUMENTATION},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_IMPORT_DOCUMENTATION, label: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_IMPORT_DOCUMENTATION},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_EXPORT_DOCUMENTATION, label: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_EXPORT_DOCUMENTATION},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_IMPORT_DOCUMENTAION, label: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_IMPORT_DOCUMENTAION},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_VISIBILITY, label: ROLES.CENTRAL_OPERATION_SUBROLES.OCEAN_VISIBILITY},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_VISIBILITY, label: ROLES.CENTRAL_OPERATION_SUBROLES.AIR_VISIBILITY},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.DOMESTIC_TRANSPORT, label: ROLES.CENTRAL_OPERATION_SUBROLES.DOMESTIC_TRANSPORT},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.VENDOR_MANAGEMENT, label: ROLES.CENTRAL_OPERATION_SUBROLES.VENDOR_MANAGEMENT},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.VEHICLE_MANAGEMENT, label: ROLES.CENTRAL_OPERATION_SUBROLES.VEHICLE_MANAGEMENT},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.DRIVER_MANAGEMENT, label: ROLES.CENTRAL_OPERATION_SUBROLES.DRIVER_MANAGEMENT},
        {value: ROLES.CENTRAL_OPERATION_SUBROLES.GROUND_OPS, label: ROLES.CENTRAL_OPERATION_SUBROLES.GROUND_OPS}

      ],

      'Product Adoption':[{value: ROLES.CENTRAL.PRODUCT_ADOPTION, label: ROLES.CENTRAL.PRODUCT_ADOPTION}],
      'Relationship Manager (Demand)':[{value: ROLES.DT.RELATIONSHIP_MANAGER_DEMAND, label: ROLES.DT.RELATIONSHIP_MANAGER_DEMAND}],
      'DT Operations':[{value: ROLES.DT.DT_OPERATIONS, label: ROLES.DT.DT_OPERATIONS}],
      'Relationship Manager (Supply)':[{value: ROLES.DT.RELATIONSHIP_MANAGER_SUPPLY, label: ROLES.DT.RELATIONSHIP_MANAGER_SUPPLY}],
      'Invoice Lead':[{value: ROLES.DT.INVOICE_LEAD, label: ROLES.DT.INVOICE_LEAD}],
      'RM (Supply),Operations & Invoicing':[{value: ROLES.DT.RMSUPPLY_OPERATIONSANDINVOICING, label: ROLES.DT.RMSUPPLY_OPERATIONSANDINVOICING}],
    }


    const handleSalesChange = (event) => {
      aguser.RMSalesVertical = []
      aguser.RMSalesVertical.push(event.target.value)
    };

    function toggleValueInArray(array, value) {
      if (array.includes(value)) {
        return array.filter(item => item !== value);
      } else {
        return [...array, value];
      }
    }


    const handleToggleSwitch = (value,index) => {
      aguser.role = toggleValueInArray(aguser.role,value)
      setRoleChecked(prevState => ({
        ...prevState,
        [index]: prevState[index] === 'Yes' ? 'No' : 'Yes'
      }));
    };

    const handleSalesToggleSwitch = (index) => {   
      setSalesChecked(prevState => ({
        ...prevState,
        [index]: prevState[index] === 'Yes' ? 'No' : 'Yes'
      }));
    };
    
    
    const currentRoleOptions = props.mode === 'edit' ? roleOptions[aguser.department] : roleOptions[department]
    // const currentRoleOptionsNew =  ServerLists.rolesList 

    const inviteMailFn = () => {

        aguser.inviteSend = true
        let u = loginStore.userRec.aguserRec
        let from = u.firstName + ' ' + u.lastName + ` <${process.env.REACT_APP_SUPPORTMAIL_ID}>`
        let to = aguser.email
        let subject = 'Invitation'
        let message = `
                        <p>Please click on <<server>> to log-on to the system.</p>
                        <p>Use the following credentials to log on and update your profile</p>
                        <table>
                        <tbody>
                        <tr>
                        <td>User Name</td><td>${aguser.email}</td>
                        </tr>
                        <tr>
                        <td>Password</td><td>${aguser.password}</td>
                        </tr>
                        </tbody>
                        </table>
                        <p></p><p>Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</p>`

        Api.sendClientMail(from, to, subject, message)
 
    }

    const isEnterpriseLocked = props.mode === 'new' && (aguser.department === ROLES.CENTRAL.CENTRAL_OPERATIONS || aguser.department === ROLES.CB.PROCUREMENT) && TenantUtils.isNavexel();
 
    return (
        <>
        <div
          className="adduserpg"
        >
            <h1 className="title">{title}</h1>
            <div className="userdetailsformv1">
          <div className="userdetailsHeader">
            <h3>User Details</h3>
          </div>

            <Columns className="is-flex">
                        <Col5>
                            <label className="labeltextNew">First Name *</label>
                            <input className="input agusersInput" style={firstNameError ? { borderColor: "red" } : null} value={aguser.firstName} ref={ref}
                                onChange={(e) => handleChange(e, 'firstName')} />
                            <p style={{ color: "red" }}>{firstNameError}</p>
                        </Col5>
                        <Col1></Col1>
                        <Col5>
                          <label className="labeltextNew">Last Name</label>
                <input className="input agusersInput" value={aguser.lastName}
                  onChange={(e) => handleChange(e, 'lastName')} />
                        </Col5>               
            </Columns>
            <Columns className="is-flex">
              <Col2  style={{  }}>
                Is {process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} User?
              </Col2>
              <Col5>  
                <div className="columns" disabled={true} style={props.mode == 'new' ? { margin: "3px" } : { pointerEvents: 'none', opacity: 0.6, margin: "3px" }}>
                  {/* <div onClick={handleClick}> */}
                    {checked1 === "Yes" ? (
                      <img height="36px" width="36px" src={on}></img>
                    ) : (
                      <img height="36px" width="36px" src={off}></img>
                    )}
                  {/* </div> */}
                </div>
              </Col5>

              {aguser.isAgragaUser === "No" && (
                <>
                <Col5>
                <label className="labeltextNew">Company</label>             
                    <input className="input agusersInput" value={aguser.companyName}
                        onChange={(e) => handleChange(e,'companyName')} />                
                </Col5>
                </>
            )}
            </Columns>
            {/*<div className="columns">
                <$cr n='2'>Password</$cr>
                <$cg n='3'>
                    <input className="input" type='password' value={aguser.password}
                        onChange={(e) => aguser.password = e.target.value} />
                </$cg>
                <$cr n='2'>Re-enter Password</$cr>
                <$cg n='3'>
                    <input className="input" type='password' value={password}
                        onChange={(e) => setPassword(e.target.value)} />
                </$cg>
    </div>*/}
            <Columns className="is-flex">
                <Col5>   
              <label className="labeltextNew">Email *</label>           
                <input
                  className="input agusersInput"
                  value={aguser.email}
                  style={emailError ? { borderColor: "red" } : null}
                  onChange={(e) => handleChange(e, "email")}
                  disabled={props.mode !== "new"}
                  onBlur={(e) => handleBlur(e, "email")}
                />
                <p style={{ color: "red" }}>{emailError}</p>             
              </Col5>
                  <Col1></Col1>
                  <Col5>             
              <label className="labeltextNew">Country</label>              
                <select className="select is-fullwidth aguserselect" value={aguser.country}
                  onChange={(e) => {
                    aguser.AdminSalesVertical = []
                    aguser.RMSalesVertical = []
                    aguser.department = ""
                    setPhoneError("")
                    aguser.phone = ""
                    aguser.country = e.target.value
                    const prefix = ServerLists.countryList.filter(e => e.name === aguser.country).map(e => e.dialCode)
                    aguser.phonePrefix = prefix[0]
                    if (aguser.country !== "India" && aguser.isAgragaUser === "Yes") {
                      aguser.vertical = VERTICALS.CROSS_BORDER
                      aguser.role = [ROLES.CB.ADMIN]
                      aguser.division = DIVISION.NATIONAL
                    } else {
                      aguser.vertical = ""
                      aguser.role = []
                      aguser.division = ""
                    }
                  }}
                  disabled={editMode() && aguser.isAgragaUser === "No"}
                >
                  <option disabled selected={aguser.isAgragaUser === "Yes"}>Select Country</option>
                  {aguser.isAgragaUser === "No" ? ServerLists.countryNameList.filter((e) => e.trim() !== "").map((e) => (<option value={e} selected={e === aguser.country}>{e}</option>)) :
                    CountryList.filter((e) => e.trim() !== "").map((e) => (<option value={e} selected={e === aguser.country}>{e}</option>))}
                </select>              
              </Col5>
            </Columns>
            <Columns className="is-flex">
               <Col5>
                <label className="labeltextNew">Phone *</label>
                
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ paddingRight: "3px" }}>
              <strong>{aguser?.phonePrefix}</strong>
            </span>
            <input
              className="input agusersInput"
              value={
                aguser?.country === "India"
                  ? aguser?.phone?.substring(0, 10)
                  : aguser?.phone?.substring(0, 15)
              }
              style={ phoneError ? { borderColor: "red" } : null}
              type="number"
              onChange={(e) => handleChange(e, "phone")}
              onBlur={(e) => handleBlur(e, "phone")}
              onKeyDown={(e) =>
                ["e", "E", "+", "-"].includes(e.key) &&
                e.preventDefault()
              }
            />
          </div>
          <p style={{ color: "red" }}>{phoneError}</p>
       
         </Col5>
            <Col1></Col1>
        {(checked1 === "Yes" && isEmailValid(aguser.email)) && (
          <>
                  <Col5>
                    <label className="labeltextNew">Vertical *</label>
                    {aguser.country === "India" && checked1 === "Yes" ?
                      <select
                        className="select is-fullwidth aguserselect"
                        value={aguser.vertical || "default"}
                        onChange={async (e) => {
                          // aguser.AdminSalesVertical =[]
                          aguser.RMSalesVertical = []
                          aguser.department = ""
                          aguser.entityCategory = ""
                          aguser.nomination = ""
                          aguser.tradeType = []
                          aguser.role = []
                          aguser.division = ""
                          aguser.reportingManager = ""
                          aguser.branch = ""
                          aguser.regional = ""
                          aguser.zonal = ""
                          aguser.national = ""
                          aguser.vertical = e.target.value
                          if (aguser.vertical === VERTICALS.CENTRAL || aguser.vertical === VERTICALS.CROSS_BORDER) {
                            await AguserApi.getManagersForAgusers(aguser.vertical, setManagersForAgusers)
                          }
                          if (props.mode == 'edit' || (props.mode == 'new' && department)) {
                            setRoleChecked({})
                            const roleList = [];
                            // if(checked1 === "No" && aguser.email && !aguser.email.includes(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)) {
                            //   aguser.department =   Object.values(CUSTOMERROLES)[0]
                            // }
                            if (aguser.vertical === VERTICALS.CROSS_BORDER) {
                              aguser.department = Object.values(ROLES.CB)[0]
                            }
                            if (aguser.vertical === VERTICALS.CENTRAL) {
                              aguser.department = Object.values(ROLES.CENTRAL)[0]
                            }
                            if (aguser.vertical === VERTICALS.DOMESTIC_TRANSPORT) {
                              aguser.department = Object.values(ROLES.DT)[0]
                            }
                            if (aguser.vertical === VERTICALS.CB_DT) {
                              aguser.department = Object.values(ROLES.CB_DT)[0]
                            }
                            const initialCheckedState = {};
                            roleOptions[aguser.department].forEach((data, index) => {
                              initialCheckedState[index] = 'Yes';
                              roleList.push(data.value)
                            });
                            setRoleChecked(initialCheckedState);
                            setDepartment(aguser.department)
                            aguser.role.push(...roleList);
                          }
                        }}
                        // style={{ width: "160px" }}
                      >
                        <option value="default" disabled>
                          Select Vertical
                        </option>
                        {Object.keys(VERTICALS).map((key) => (
                          <option value={VERTICALS[key]}>{VERTICALS[key]}</option>
                        ))}
                      </select>
                      :
                      <select
                        className="select is-fullwidth aguserselect"
                        value={aguser.vertical = "Cross-Border"}
                        // style={{ width: "160px" }}
                        disabled={true}
                      >
                        {Object.keys(VERTICALS).map((key) => (
                          <option value={VERTICALS[key] === "Cross-Border"}>{VERTICALS[key]}</option>
                        ))}
                      </select>}

                  </Col5>
                  </>
                )}
            </Columns>
         <Columns className="is-flex">
                {(aguser.isAgragaUser === "Yes" && isEmailValid(aguser.email) && aguser.vertical !== '') &&
                <>
                 <Col5>                 
                  <label className="labeltextNew">Department *</label>       
                  <select
                    className="select is-fullwidth aguserselect"
                    // value={aguser.department ? aguser.department : "default"}
                    value ={aguser.department || (aguser.country !== 'India' ? 'Admin' : 'default')}
                    disabled={(checked1 === "Yes" && isEmailValid(aguser.email) &&aguser.isAgragaUser==="Yes" && aguser.country !=="India" && aguser.role)}
                    onChange={(e) => {
                      // aguser.AdminSalesVertical =[]
                      aguser.RMSalesVertical =[]
                      handleChange(e, "role")
                        if ( aguser.vertical === 'Cross-Border' && e.target.value === ROLES.CB.RELATIONSHIP_MANAGER && salesVerticalOptions.length > 0) {
                        aguser.RMSalesVertical.push(salesVerticalOptions[0]);
                      }
                      const roleList= [];
                      setDepartment(e.target.value)
                      const initialCheckedState = {};
                        roleOptions[e.target.value].forEach((data, index) => {
                          initialCheckedState[index] = 'Yes';
                          roleList.push(data.value)
                        });
                        setRoleChecked(initialCheckedState);                    

                      if (!Array.isArray(aguser.role)) {
                        aguser.role = [];
                      }

                      aguser.role.push(...roleList);
                      aguser.department =  e.target.value;  

                      // Reporting Manager service call
                      rmOnChnage(aguser.role)

                      // Reset other related fields
                      aguser.zonal = ""
                      aguser.branch = ""
                      aguser.regional = ""
                      aguser.division = ""
                      aguser.reportingManager = ""
                      aguser.entityCategory=""
                      aguser.cargoHandlingType = ''
                      aguser.branches = []
                      setValue('branches', [])
                      aguser.products = []
                      aguser.tradeTypes = []
                      aguser.nominations = []
                      aguser.subRoles = []
                      aguser.customers = []
                      aguser.originClearance = [];
                      aguser.destinationClearance = [];
                      aguser.originTransport = [];
                      aguser.destinationTransport = [];
                      // aguser.nomination=""
                      // aguser.tradeType=[]

                      if (
                        TenantUtils.isNavexel() &&
                        props.mode === 'new' &&
                        (e.target.value === ROLES.CENTRAL.CENTRAL_OPERATIONS || e.target.value === ROLES.CB.PROCUREMENT)
                      ) {
                        aguser.entityCategory = ENTITYCATEGORY.Enterprise;
                      }
                    }}               
                  >
                    <option value="default" disabled>
                      Select Department
                    </option>
                    {
                      (checked1 === "No" && aguser.email && !aguser.email.includes(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)) &&
                      Object.keys(CUSTOMERROLES).map((key) => (
                        <option key={key} value={CUSTOMERROLES[key]}>
                          {CUSTOMERROLES[key]}
                        </option>
                      ))}
                    {aguser.vertical === VERTICALS.CROSS_BORDER &&
                      Object.keys(ROLES.CB).map((key) => (
                        <option key={key} value={ROLES.CB[key]}>
                          {ROLES.CB[key]}
                        </option>
                      ))}
                    {aguser.vertical === VERTICALS.CENTRAL &&
                      Object.keys(ROLES.CENTRAL)?.map((key) => (
                        <option key={key} value={ROLES.CENTRAL[key]}>
                          {ROLES.CENTRAL[key]}
                        </option>
                      ))}
                    {aguser.vertical === VERTICALS.DOMESTIC_TRANSPORT &&
                      Object.keys(ROLES.DT).map((key) => (
                        <option key={key} value={ROLES.DT[key]}>
                          {ROLES.DT[key]}
                        </option>
                      ))}
                         {aguser.vertical === VERTICALS.CB_DT &&
                      Object.keys(ROLES.CB_DT).map((key) => (
                        <option key={key} value={ROLES.CB_DT[key]}>
                          {ROLES.CB_DT[key]}
                        </option>
                      ))}
                      {(aguser?.country!=='India')&& (<option value='Admin'selected>
                        Admin
                      </option>)}
                   </select>                   
                  </Col5>
                  </>}
                 
                  
                {/* {
                  (aguser.role)
                } */}
                {/* {(aguser.isAgragaUser === "Yes" && isEmailValid(aguser.email)) && aguser.vertical && aguser.role( */}
                      {/* )} */}
              
          

                <Col1></Col1>
                {(aguser.isAgragaUser === "Yes" && isEmailValid(aguser.email)) && aguser.vertical && (aguser.role && aguser.role.length > 0) && (
                  <>
                  <Col5>               
                     <label className="labeltextNew">Division*</label>                   
                    {aguser.country==="India" && aguser.isAgragaUser ==="Yes"?
                      <select
                        className="select is-fullwidth aguserselect"
                        value={aguser.division || "default"}
                        disabled={
                          (aguser.role.includes(ROLES.CB.BRANCH_HEAD) && aguser.division === DIVISION.BRANCH) || (aguser.division === DIVISION.NATIONAL && aguser.vertical === VERTICALS.CENTRAL)
                        }
                        onChange={(e) => {
                          aguser.zonal = ""
                          aguser.branch = ""
                          aguser.regional = ""
                          aguser.division = e.target.value
                          aguser.reportingManager = ""

                        const initialSalesCheckedState = {};
                        cbAdminSalesVertical.forEach((data, index) => {
                            initialSalesCheckedState[index] = 'No';
                        });
                        setSalesChecked(initialSalesCheckedState);
                          // if (aguser.division != 'National') {
                          divisonOnChnage()
                          // }
                          // else {
                          //     rmOnChnage()
                          // }
                        }}                    
                        readOnly={true}
                       >
                        {
                        (aguser.vertical == VERTICALS.CENTRAL &&
                          (aguser.role.some(role => Object.values(ROLES.CENTRAL).includes(role)) || aguser.department == 'Central Operations')
                        ) ? 
                        (
                          <>
                            {(aguser.division = "National")}
                            <option value="default">National</option>
                          </>
                        ) : 
                        
                        
                            
                        (aguser.vertical == VERTICALS.DOMESTIC_TRANSPORT && isBranchHeadRole) ||
                          (aguser.vertical == VERTICALS.CROSS_BORDER && isBranchHeadRole) ||
                          // (aguser.vertical == VERTICALS.CROSS_BORDER && aguser.role == ROLES.CB.PROCUREMENT)||
                          (aguser.vertical == VERTICALS.CB_DT && isBranchHeadRole) ||
                          (aguser.vertical == VERTICALS.DOMESTIC_TRANSPORT &&
                            aguser.role.includes(ROLES.DT.RMSUPPLY_OPERATIONSANDINVOICING)) ? 
                        (
                          <>
                            {(aguser.division = "Branch")}
                            <option value="default">Branch</option>
                          </>
                        ) :
                         (aguser.vertical == VERTICALS.DOMESTIC_TRANSPORT && isAdminRole) ||
                          (aguser.vertical == VERTICALS.CROSS_BORDER && isAdminRole) || 
                            // (aguser.vertical == VERTICALS.CROSS_BORDER && aguser.role == ROLES.CB.PROCUREMENT ) ||
                            // (!aguser.vertical == "Cross-Border" && !aguser.role == "Procurement") ||
                            (aguser.vertical == VERTICALS.CB_DT && isAdminRole) ? 
                            (
                              <>
                                <option value="default" disabled>
                                  Select Division
                                </option>
                                {Object.keys(DIVISION).map((key) => {
                                  if ((aguser.vertical === "Cross-Border" && DIVISION[key] === "Regional")
                                  // ||(aguser.vertical == "Cross-Border" && aguser.role == "Procurement")
                                   // (aguser.vertical === "CB-DT" && DIVISION[key] === "Regional")|| 
                                  || (!isAdminRole && DIVISION[key] === "National") 
                                || DIVISION[key] === 'Branch') {
                                    return null
                                  }
                                  return (
                                    
                                    <option value={DIVISION[key]} key={key}>
                                      
                                      {DIVISION[key]}
                                    </option>
                                  )
                                })}
                              </>
                            ) :
                            (
                              <>
                                <option value="default" disabled>
                                  Select Division
                                </option>
                                {Object.keys(DIVISION).map((key) => {
                                  
                                  if ((aguser.vertical === "Cross-Border" && DIVISION[key] === "Regional") 
                                  || (!(aguser.vertical === "Cross-Border") && DIVISION[key] === "National")
                                ) {
                                    return null
                                  }
                                  return (
                                    
                                    <option value={DIVISION[key]} key={key}>
                                      
                                      {DIVISION[key]}
                                    </option>
                                  )
                                })}
                              </>
                            ) 
                            
                        }
                      </select>
                      :
                      <select
                      className="select is-fullwidth aguserselect"
                      value={aguser.division="National"}
                      disabled={checked1==="Yes"}
                      style={{ width: "160px" }} 
                    > 
  
                          <option value="National">National</option>

                    </select>
                      }
                   
                    </Col5>
                  </>
                )} 
                
              </Columns>
              <Columns className="is-flex">
            {((((department !== '' && props.mode === 'new') || (aguser.department !== '' && editMode())) && isEmailValid(aguser.email) && aguser.vertical != '')  && (aguser?.department !== 'Admin' || aguser.vertical !== 'Cross-Border') &&  (aguser?.department !== 'Relationship Manager' || aguser.vertical !== 'Cross-Border') ) && (
              <>
                <Col5>               
                 <label className="labeltextNew">Role*</label>               
                  <div
                    className="columns"
                    style={{ margin: '3px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                  >
                    {
                  currentRoleOptions?.map((data, index) => (
                <label key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                  <input
                    type="checkbox"
                    checked={props.mode == 'edit'?aguser.role.includes(data.value):roleChecked[index] === 'Yes'}
                    onChange={() => handleToggleSwitch(data.value,index)}
                    style={{ display: 'none' }}
                    disabled={currentRoleOptions.length === 1}
                  />

                  <img
                      height="36px"
                      width="36px"
                      src={props.mode === 'edit' ? (aguser.role.includes(data.value) ? on : off) : (roleChecked[index] === 'Yes' ? on : off)}
                      alt={props.mode === 'edit' ? (aguser.role.includes(data.value) ? 'On' : 'Off') : (roleChecked[index] === 'Yes' ? 'On' : 'Off')}
                    />
                <span style={{ marginLeft: '8px' }}>{data.label}</span>
                </label>
              ))}
                  </div>
                
                </Col5>
                <Col1></Col1>
              </>
            )}


    {(aguser.department === 'Admin' && aguser.vertical === 'Cross-Border' && aguser.country === 'India' &&(aguser.division === 'National' || (aguser.division === 'Zonal' && aguser.zonal != ''))) && (
              <>
                <Col5>              
                <label className="labeltextNew">Sales Vertical*</label>               
                  <div
                    className="columns"
                    style={{ margin: '3px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                  >
                    {
                  cbAdminSalesVertical?.map((data, index) => (
                <label key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                  <input
                    type="checkbox"
                    onChange={() => {
                      handleSalesToggleSwitch(index)
                    }
                    }
                    style={{ display: 'none' }}
                  />
                  <img
                      height="36px"
                      width="36px"
                      src={salesChecked[index] === 'Yes' ? on : off}
                      alt={salesChecked[index] === 'Yes' ? 'On' : 'Off'}
                    />
                <span>{data}</span>
                </label>              
))}
                  </div>                
                </Col5>
                <Col1></Col1>
              </>
            )}
  
  {(aguser.vertical === 'Cross-Border' && aguser.department === ROLES.CB.RELATIONSHIP_MANAGER && aguser.country === 'India' && ((aguser.division === 'Zonal' && aguser.zonal != '') || (aguser.division === 'Branch' && aguser.branch != '')||(aguser.division==='National'))) && (
            <>
             <Col5>           
               <label className="labeltextNew">Sales Vertical*</label>            
                <div>
                  {salesVerticalOptions.map((value, index) => (
                    <label key={index} style={{ display: 'block', marginBottom: '8px' }}>
                      <input type="radio" name="salesVertical" value={value} style={{marginRight:'20px'}} onChange={handleSalesChange} defaultChecked={props.mode === 'new' ? index === 0: (aguser.RMSalesVertical.length > 0)? aguser.RMSalesVertical[0] === value:index === 0}/>
                      {value}
                    </label>
                  ))}
                </div>              
              </Col5>
              <Col1></Col1>
            </>)        
            }
            

            {(checked1 === "Yes" && isEmailValid(aguser.email)) &&
                  ((aguser.division == "National" &&  aguser.vertical === VERTICALS.CENTRAL) ||  aguser.vertical === VERTICALS.CROSS_BORDER) && aguser.vertical !== VERTICALS.DOMESTIC_TRANSPORT &&aguser.vertical !== VERTICALS.CB_DT && (
                    <>
                     <Col5>           
                         <label className="labeltextNew">Reporting Manager</label>
                        <select
                          className="select is-fullwidth aguserselect"
                          // value={aguser.reportingManager || "default"}
                          value={
                            managersForAgusers.filter(e => e.status === 'ACTIVE')
                              .some(e => e._id === aguser.reportingManager)
                              ? aguser.reportingManager
                              : "default"
                          }
                          onChange={(e) => {
                            aguser.reportingManager = e.target.value
                          }}
                       
                        >
                          <option value="default" disabled>
                            Select Reporting Manager
                          </option>
                          {managersForAgusers.filter((e) => e.status === 'ACTIVE').map((e) => (
                            <option value={e._id}>
                              {e.firstName +
                                " " +
                                e.lastName +
                                "  " +
                                " ( " +
                                e?.email +
                                " ) "}
                            </option>
                          ))}
                        </select>                      
                      </Col5>
                    </>
                  )}
              </Columns>

        <Columns className="is-flex">
          <Col5>         
          <label className="labeltextNew">Select Role *</label>       
       
          <div   ref={dropdownRef} style={{ position: "relative" , border : "1px solid rgb(183, 182, 182)" }}>
            <div
              className="border rounded px-3 py-2 cursor-pointer bg-white flex flex-wrap gap-2 items-center min-h-[40px] relative w-auto"
              onClick={toggleDropdown}
            >
              <div className="flex flex-wrap gap-1 flex-grow">
                {aguser.rolePerm?.length > 0 ? (
                  aguser.rolePerm.map((dept) => (
                    <span key={dept} className="bg-[#E0E7FF] text-gray-700 px-2 py-1 rounded-full text-sm flex items-center border border-gray-300">
                      {dept}
                    </span>
                  ))
                ) : (
                  <span className="text-gray-500">Select Role</span>
                )}
              </div>

              <img
                src={DropdownIcon}
                alt="Dropdown Icon"
                className={`w-5 h-5 absolute right-3 top-1/2 transform -translate-y-1/2 transition-transform ${isOpen ? "rotate-180" : "rotate-0"
                  }`}
              />
            </div>

            {isOpen && (
              <div className="absolute mt-1 bg-white border rounded shadow-xl max-h-40 overflow-auto z-10"  style={{ width: "100%", zIndex: 20 }}>
                {
                  rolesList?.map((key) => (
                    <label key={key} className="flex items-center p-2 hover:bg-gray-100 cursor-pointer">
                      <input
                        type="checkbox"
                        className="mr-2"
                        checked={aguser?.rolePerm?.includes(key._id)}
                        onChange={(e) => handleCheckboxChange(key._id)}
                      />
                      {key.roleName}
                    </label>
                  ))}
              </div>
            )}
          </div>        
          </Col5>
           <Col1></Col1>
              {(aguser.department === "Central Operations" || aguser.department == 'Procurement' || aguser.department == 'Finance') && <>
                <Col5>
                  {/* <$cr n="2">Entity Category*</$cr> */}
                  <label className="labeltextNew">Entity Category*</label>  
               
                    <select
                      className="select is-fullwidth aguserselect"
                      value={isEnterpriseLocked ? ENTITYCATEGORY.Enterprise : aguser.entityCategory || "default"}
                      disabled={isEnterpriseLocked}
                      onChange={async (e) => {
                        aguser.entityCategory = e.target.value;
                      }}                     
                    >
                      <option value="default" disabled>
                        Select Entiy Category
                      </option>
                      {Object.keys(ENTITYCATEGORY).map((key) => (
                        <option value={ENTITYCATEGORY[key]}>{ENTITYCATEGORY[key]}</option>
                      ))}
                    </select>                  
                </Col5>
              </>}           
        
        </Columns>
      <Columns className="is-flex">
                      {props.mode !== "new" ? (
                      <>
                       <Col5>         
                         <label className="labeltextNew">Status</label>                  
              <select
                className="select is-fullwidth aguserselect"
                value={aguser.status}
                onChange={(e) => (aguser.status = e.target.value)}
              >
              
                {/* <option value="ACCEPTED">ACCEPTED</option> */}
                {(!aguser.inviteSend && aguser.status !== undefined ) ? <>
                  <option value="ACTIVE">ACTIVE</option>
                </>: <>              
                {/* {
                  userdata.status === 'NEWREG' && 
                  <option value="NEWREG">NEWREG</option>
                } */}                  
                <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
                </>

                }
             
              </select>          
            </Col5>
             <Col1></Col1>
          </>
        ) : (
          <></>
        )}
 

{(checked1 === "Yes" && isEmailValid(aguser.email)) &&
                  aguser.division &&
                  aguser.division != "National" &&
                  aguser.vertical != VERTICALS.CENTRAL && (aguser.role && aguser.role.length > 0) && (
                    <>
                      {/* {aguser.division=='Zonal' && 
                      (aguser.division='Zone')} */}
                      <Col5>
                      <label className="labeltextNew">{aguser.division == 'Zonal' ? 'Zone*' : (aguser.division == 'Regional') ? 'Region*' : aguser.division + '*'}</label>  
                    
                        <select
                          className="select is-fullwidth aguserselect"
                          value={getType() || "default"}
                          onChange={(e) => {                            
                             
                            const initialSalesCheckedState = {};
                            cbAdminSalesVertical.forEach((data, index) => {
                                initialSalesCheckedState[index] = 'No';
                            });
                            setSalesChecked(initialSalesCheckedState);

                            const division = aguser.division.toLowerCase()
                            aguser[division] = e.target.value
                            console.log(e.target.value, division, "rrrr")
                            aguser.reportingManager = ""
                          }}                         
                        >
                          <option value="default" disabled>
                            Select
                          </option>
                          
                          {
                           branchesForTypes.length > 0 && branchesForTypes[0]?.branch
                            ? branchesForTypes.map((e) => {
                              if (e.hasBranchHead) {
                                return (
                                  <option value={e.branch} disabled>
                                    {e.branch}
                                  </option>
                                )
                              } else {
                                return <option value={e.branch}>{e.branch}</option>
                              }
                              
                            })
                            : 
                            
                            branchesForTypes.length > 0 &&branchesForTypes.map((e) =>                           
                             (                              
                              <option value={e}>{e}</option>
                            ))}
                        </select>                     
                      </Col5>
                    </>
                  )}
      </Columns>

        {aguser.isAgragaUser === "Yes" &&
          <Columns className="is-flex">
            <Col5>       
          <label className="labeltextNew">ERP Employee Code</label>          
            <input className="input agusersInput" value={aguser.erpEmployeeCode}
              onChange={(e) => handleChange(e, 'erpEmployeeCode')} />          
          </Col5>
           <Col1></Col1>
          {(aguser.department === 'Procurement') && (
              <>
                <Col5>
                 <label className="labeltextNew">Nomination *</label>               
            
                  <select
                    className="select is-fullwidth aguserselect"
                    value={aguser.nominations || "default"}
                    onChange={(e) => {
                      aguser.nominations = e.target.value;
                    }}                  
                  >
                    <option value="default" disabled>
                      Select Nomination
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Both">Both</option>
                  </select>
                
                </Col5>
              </>
            )}
        </Columns>}

        {   <Columns className="is-flex">
                  {(aguser.department === "Central Operations" || aguser.department ==  'Procurement') && <>     
                  <Col5> 
             <label className="labeltextNew">Cargo Handling Type*</label>               
              <select
                className="select is-fullwidth aguserselect"
                value={aguser.cargoHandlingType || "default"}
                onChange={async(e) => {
                   aguser.cargoHandlingType = e.target.value;
                }}             
              >
                <option value="default" disabled>
                  Select Cargo Handling
                </option>
                {Object.keys(CARGOHANDLINGTYPE).map((key) => (
                  <option value={CARGOHANDLINGTYPE[key]}>{CARGOHANDLINGTYPE[key]}</option>
                ))}
              </select>   
              </Col5>   
              </>         
               }
               <Col1></Col1>
          {(aguser.department === "Procurement") && (
              <>
               
                 <label className="labeltextNew">Trade Type*</label>    
                 <div
                    className="columns"
                    style={{
                      margin: "3px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    {["Import", "Export", "CrossTrade"].map((trade, index) => (
                      <label
                        key={trade}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "8px",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={aguser.tradeTypes?.includes(trade) || false}
                          onChange={() => {
                            if (!Array.isArray(aguser.tradeTypes)) {
                              aguser.tradeTypes = [];
                            }
                            aguser.tradeTypes = aguser.tradeTypes.includes(trade)
                              ? aguser.tradeTypes.filter((item) => item !== trade)
                              : [...aguser.tradeTypes, trade];
                          }}
                          style={{ display: "none" }}
                        />
                        <img
                          height="36px"
                          width="36px"
                          src={aguser.tradeTypes?.includes(trade) ? on : off}
                          alt={aguser.tradeTypes?.includes(trade) ? "On" : "Off"}
                        />

                        <span style={{ marginLeft: "8px" }}>
                          {trade}
                        </span>
                      </label>
                    ))}
                  </div>                
              </>
            )}
                </Columns>
        }
        { aguser.vertical === VERTICALS.CENTRAL  &&  <Columns className ="is-flex">
              <Col5>
                <div className="is-flex">
                <span style={{ marginRight: "15%" }}>Is Sales ? </span>
                <label key='isSales' style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>                
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      aguser.isSales = e.target.checked
                      if(!e.target.checked){
                         aguser.salesUserType = ""
                      }
                    }
                    }
                    style={{ display: 'none' }}
                  />
                  <img
                    height="36px"
                    width="36px"
                    src={aguser.isSales ? on : off}
                    alt={aguser.isSales ? 'On' : 'Off'}
                  />
                </label>
                </div>
              </Col5>
           <Col1></Col1>
              {aguser.isSales &&
                <Col5>
                  <label className="labeltextNew">Sales User Type</label>
                  <select
                    className="select is-fullwidth aguserselect"
                    value={aguser.salesUserType}
                    onChange={async (e) => {
                      aguser.salesUserType = e.target.value;
                    }}
                  >
                    <option value="" disabled>
                      Select Sales User Type
                    </option>
                    <option value="Relationship Manger">Relationship Manger</option>
                    <option value="Customer Success">Customer service</option>
                  </select>
                </Col5>
              }
          </Columns>
        }

      {checked1 === "No" && (
        <Columns className="is-flex">
                <Col2>
                  <label className="labeltextNew"> Client ID</label>
                </Col2>
                <Col8>        
                        {aguser.client_id ? (aguser.client_id) : (<a className="button"  style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                        onClick={() => {
                            aguser.client_id = bin2hex()
                        }}>Generate</a>
                    )}
                
                </Col8>
            </Columns>
      )}
      {checked1 === "No" && (
            <Columns className="is-flex">
               <Col1>                 
                </Col1>          
                <Col9>
                    <UserEntity onValidationComplete={handleValidationComplete} />
                </Col9>
            </Columns>
      )}
       </div>
          
          { (aguser.department === 'Finance' ||  aguser.department === 'Central Operations' ) && 
            <div className="userdetailsformv1 mt-4">
              <div className="userdetailsHeader">
                <h3>Branch & Access Mapping</h3>
              </div>
              <Columns className="is-flex">
                {(aguser.department === 'Finance' || aguser.department === 'Central Operations') &&
                  <>
                    <Col5>
                      <MultiSelectField
                        labelStyle={{
                          fontSize: "12px",            
                          fontWeight: "bold",
                        }}
                        name="branches"
                        control={control}
                        label={"Branch *"}
                        placeholder="Select Branch"
                        // options={branchesForTypes}
                        // options={branchesForTypes.map(branch => ({
                        //   label: branch,
                        //   value: branch
                        // }))}

                        options={
                          branchesForTypes?.length > 0 && branchesForTypes[0]?.branch
                            ? branchesForTypes.map((e) => ({
                              label: e.branch,
                              value: e.branch,
                            }))
                            : branchesForTypes?.length > 0
                              ? branchesForTypes.map((branch) => ({
                                label: branch,
                                value: branch,
                              }))
                              : []
                        }
                        // rules={{ required: "Required" }}
                      //   onInputChangeValue={onInputChangeValue}
                      //   callback={externalChangeValue}
                      //   disabled={isView}
                      />
                    </Col5>
                  </>
                }

                <Col1></Col1>     
                   { aguser.department === 'Central Operations' && <>         
                  <Col5>
                    

                    <MultiSelectField
                      labelStyle={{
                        fontSize: "12px",      
                        fontWeight: "bold",
                      }}
                      name="products"
                      control={control}
                      label={"Product *"}
                      placeholder="Select Product"
                      // options={branchesForTypes}
                      options={productTypes.map(product => ({
                        label: product,
                        value: product
                      }))}
                      // rules={{ required: "Required" }}
                    //   onInputChangeValue={onInputChangeValue}
                    //   callback={externalChangeValue}
                    //   disabled={isView}
                    />
                  </Col5>     
                  </> }  

              </Columns>
              { aguser.department === 'Central Operations' && <>
               <Columns className="is-flex">
                <Col5>               
                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",
                      // color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      fontWeight: "bold",
                    }}
                    name="tradeTypes"
                    control={control}
                    label={"Trade Type *"}
                    placeholder="Select Trade Types"
                    // options={branchesForTypes}
                    options={tradeTypes.map(trade => ({
                      label: trade,
                      value: trade
                    }))}
                    // rules={{ required: "Required" }}
                    />
                </Col5>
                <Col1></Col1>
                 <Col5>                 

                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",  
                      fontWeight: "bold",
                    }}
                    name="subRoles"
                    control={control}
                    label={"Sub Role *"}
                    placeholder="Select Sub Role"
                    // options={branchesForTypes}
                    options={subroletypes.map(role => ({
                      label: role,
                      value: role
                    }))} />
                       {/* rules={{ required: "Required" }} */}
                </Col5>
                {/* <Col5>     

                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      fontWeight: "bold",
                    }}
                    name="cargoHandlingTypes"
                    control={control}
                    label={"Cargo Handling Type"}
                    placeholder="select type"
                    // options={branchesForTypes}
                    options={Object.keys(CARGOHANDLINGTYPE).map((key) => ({
                      label: CARGOHANDLINGTYPE[key],
                      value: CARGOHANDLINGTYPE[key]
                    }))}
                  />
                </Col5> */}
              </Columns>
              {/* <Columns className="is-flex">
                <Col5>             

                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      fontWeight: "bold",
                    }}
                    name="entitySalesVerticals"
                    control={control}
                    label={"Entity Sales Vertical"}
                    placeholder="select Verticals"
                    // options={branchesForTypes}
                    options={Object.values(SALESVERTICAL).map((r, i) => ({
                      label: r,
                      value: r
                    }))}
                  />
                </Col5>
                <Col1></Col1>
                <Col5>                 

                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      fontWeight: "bold",
                    }}
                    name="subRoles"
                    control={control}
                    label={"Sub Role"}
                    placeholder="select Sub Role"
                    // options={branchesForTypes}
                    options={subroletypes.map(role => ({
                      label: role,
                      value: role
                    }))} />
                </Col5>
              </Columns> */}
              <Columns className="is-flex">
                <Col5>               

                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",
                         fontWeight: "bold",
                    }}
                    name="nominations"
                    control={control}
                    label={"Nomination *"}
                    placeholder="Select Nomination"
                    // options={branchesForTypes}
                    options={nominationtypes.map(type => ({
                      label: type,
                      value: type
                    }))}
                      // rules={{
                      //   validate: (value) =>
                      //     Array.isArray(value) && value.length > 0
                      //       ? true
                      //       : "Please select at least one nomination type",
                      // }}

                  />
                </Col5>
                <Col1></Col1>
                <Col5>
                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",    
                      fontWeight: "bold",
                    }}
                    name="customers"
                    control={control}
                    label={"Customers"}
                    placeholder="Select Customers"
                    // options={branchesForTypes}
                    options={cuslist?.map(entity => ({
                      label: entity.entityName,
                      value: entity.entityId
                    }))}
                  /></Col5>
              </Columns>

              <Columns>
                <Col5>
                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",     
                      fontWeight: "bold",
                    }}
                    name="originClearance"
                    control={control}
                    label={"Origin clearance"}
                    placeholder="Select Origin Clearance"
                    // options={branchesForTypes}
                    options={Countries?.map((e) => ({
                      label: e.name,
                      value: e.name
                    }))}

                  />
                </Col5>
                <Col1></Col1>
                <Col5>
                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px", 
                      fontWeight: "bold",
                    }}
                    name="destinationClearance"
                    control={control}
                    label={"Destination Clearance"}
                    placeholder="Select Destination Clearance"
                    // options={branchesForTypes}
                    options={Countries?.map((e) => ({
                      label: e.name,
                      value: e.name
                    }))}

                  />
                </Col5>
              </Columns>
              <Columns>
                <Col5>
                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",    
                      fontWeight: "bold",
                    }}
                    name="originTransport"
                    control={control}
                    label={"Origin Transport"}
                    placeholder="Select Origin Transport"
                    // options={branchesForTypes}
                    options={Countries?.map((e) => ({
                      label: e.name,
                      value: e.name
                    }))}

                  />
                </Col5>
                <Col1></Col1>
                <Col5>
                  <MultiSelectField
                    labelStyle={{
                      fontSize: "12px",
                      // color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      fontWeight: "bold",
                    }}
                    name="destinationTransport"
                    control={control}
                    label={"Destination Transport"}
                    placeholder="Select Destination Transport"
                    // options={branchesForTypes}
                    options={Countries?.map((e) => ({
                      label: e.name,
                      value: e.name
                    }))}

                  />
                </Col5>
              </Columns>  
              <Columns>
               <Col5>
                 <div className="is-flex">
                 <span style={{ marginRight : "15%"}}>Is Carrier Tracking ? </span>
                    <label key='isCarrierTracking' style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>                
                      <input
                        type="checkbox"
                        onChange={(e) => {                       
                         aguser.isCarrierTracking = e.target.checked
                        }
                        }
                        style={{ display: 'none' }}
                      />
                      <img
                        height="36px"
                        width="36px"
                        src={ aguser.isCarrierTracking  ? on : off}
                        alt={aguser.isCarrierTracking ? 'On' : 'Off'}
                      />                     
                    </label>    
                    </div>
               </Col5>
              </Columns>
              </>
              }
                 


            </div>
          }

            <div style={{ marginTop : "2%"}}>
            <Columns className="is-flex" >
              {/* <Col1>
              </Col1>
              <Col8 style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                  class="button is-danger"
                  onClick={() => {
                    AgmodalStore.pageVisible = false;
                    AgmodalStore.apiCall = true;
                  }}
                >
                  Cancel
                </button>
                <button
                  className="button is-primary"
                  onClick={(e) => {
                    handleSubmit(e)
                  }}
                > Save
                </button>
              </Col8> */}   
               <div className="btnContainer">        
               <button
                  className="cancelbtnNew"
                  onClick={() => {
                    AgmodalStore.pageVisible = false;
                    AgmodalStore.apiCall = true;
                  }}
                >
                  Cancel
                </button>
                  <button
                  className="savebtnNew"
                  onClick={(e) => {
                    handleSubmit(e)
                  }}
                > Save
                </button>               
              {/* <$cr n="2"></$cr> */}              
                {
                  (showInvite && aguser.status === 'ACTIVE') ?
                    <button className="inviteuserBtn" onClick={() => {
                      if (!loading) {
                        setLoading(true)
                        aguser.inviteSend = true
                        let u = loginStore.userRec.aguserRec
                        let from = u.firstName + ' ' + u.lastName + ` <${process.env.REACT_APP_SUPPORTMAIL_ID}>`
                        let to = aguser.email
                        let subject = 'Invitation'
                        let message = `
                        <p>Please click on <<server>> to log-on to the system.</p>
                        <p>Use the following credentials to log on and update your profile</p>
                        <table>
                        <tbody>
                        <tr>
                        <td>User Name</td><td>${aguser.email}</td>
                        </tr>
                        <tr>
                        <td>Password</td><td>${aguser.password}</td>
                        </tr>
                        </tbody>
                        </table>
                        <p></p><p>Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</p>`

                        Api.sendClientMail(from, to, subject, message)
                        setLoading(false)
                      }
                    }}> {!aguser.inviteSend ? 'Invite User' : 'Re-Invite User'}</button> :
                    <></>
                }
                </div>  
             
            </Columns>
            </div>  
           
            </div>
        </>
    )
}